exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-3eea0ed6]{font-size:16px;height:36px;background:#f5f7fa;line-height:36px;padding-left:22px}\n", ""]);

// exports
